export default __webpack_public_path__ + "static/media/fridge2-beforeA-1440w.c6334135.png";